import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { forgotPasswordEmailInterface, forgotPasswordPayloadModel, loginPayloadModel, MacSsoVerifyUserPayloadModel, Plan401kPayloadModel, userLogoutResponseDataModel, UserRegistrationPayloadModel } from '../models/axiosModels';
import { AppAccessRequestInterface, AppApproveRejectInterface, AppsOrderPayload, deleteResourceFileInterface, getRevenuePayloadData, MarketAndSalesResourcePayloadDataModel, updateResourceInterface, UserProfileDetailsPayloadModel } from '../models/dashboardAxiosModels';
import { AcrylicTeamMemberPayloadModel, appGroupIdPayload, GetAcrylicPayloadModel, GetUserCredPayloadModel, GetUserDetailsPayloadModel, GroupAppStatusRequestPayload, UpdateMemberDetailsPayload, UpdateUserStatusByPayloadModel, UsersResponseModel } from '../models/memberAxiosModels';
import { RemoveProfileCredPayload } from '../models/userDetailsModel';


axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_CALL_URL;
// axios.defaults.baseURL = "http://192.168.1.2:3000";

axios.interceptors.response.use(
    response => response,
    error => {
        if (error?.status == 401) {
            const currentPath = ['/login', '/reset-password', '/register', '/verify-user', '/macsso/ssohome'];
            // Prevent infinite redirect loop
            if (!currentPath?.includes(window.location.pathname)) {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);
let apiBuffer: Array<{ name: string, controller: AbortController }> = [];

const responseBody = (response: any) => {
    if (response?.Title === undefined)
        return response.data
}

const Error = (err: AxiosError) => {
    // @ts-ignore
    if (err?.response !== null && err?.response !== undefined) {
        console.log("response.response.data.error--", err?.response?.data)
    }
    if (err && err.response && err.response.data) {
        return err.response.data;
    }
    return err;
}

const requests = {

    get: async (url: string) => {
        try {
            // @ts-ignore
            const controller = new AbortController();
            // @ts-ignore
            apiBuffer.push({ name: url, controller: controller })
            const response = await axios.get(url,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    signal: controller.signal
                });
            // @ts-ignore
            if (response?.flagStatus === false && response?.error !== "" && response?.error !== null && response?.error !== undefined) {
                alert("Something went wrong.!");
            }
            else {
                return responseBody(response);
            }
        }
        catch (err: any) {
            return Error(err);
        }
    },

    fileUploadPost: async (url: string, body: any) => {
        try {
            const response = await axios.post(url, body, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            return responseBody(response);
        }
        catch (err: any) {
            return Error(err);
        }
    },

    post: async (url: string, body: any, config?: AxiosRequestConfig<any>) => {
        try {
            const controller = new AbortController();
            apiBuffer.push({ name: url, controller: controller })
            let additionalConfig: AxiosRequestConfig<any> = {
                headers: {
                    "Content-Type": "application/json"
                }
            };
            if (config) {
                additionalConfig = {
                    ...config,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
            const response = await axios.post(url, body, additionalConfig);
            return responseBody(response);
        }
        catch (err: any) {
            if (axios.isCancel(err)) {
                console.log("Request was canceled", err);
                // @ts-ignore
                apiBuffer = apiBuffer.filter((api: any) => api.name !== url)
            } else {
                console.log("not aborted", err)
            }
            return Error(err);

        }
    },

    // post: async (url: string, body: any, onAbort?: () => void, config?: any) => {
    //     try {
    //         // @ts-ignore
    //         const controller = new AbortController();
    //         // @ts-ignore
    //         apiBuffer.push({ name: url, controller: controller })
    //         // @ts-ignore
    //         const response = await axios.post(url, body, {
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             signal: controller.signal,
    //             ...config,
    //         });
    //         return responseBody(response);

    //         // return response.data;
    //     }
    //     catch (err: any) {
    //         if (axios.isCancel(err)) {
    //             console.log("Request was canceled", err);
    //             // @ts-ignore
    //             apiBuffer = apiBuffer.filter((api: any) => api.name !== url)
    //             if (onAbort) console.log("onabort called");
    //         } else {
    //             console.log("not aborted", err)
    //         }
    //         return Error(err);
    //     }
    // },

    put: async (url: string, body: any, params?: Record<string, any>) => {
        try {
            const response = await axios.put(url, body, {
                headers: { "Content-Type": "application/json" },
                params
            });
            return responseBody(response);
        } catch (err: any) {
            return Error(err);
        }
    },

    // delete: async (url: string) => {
    //     try {
    //         const response = await axios.delete(url, {
    //             headers: {
    //                 "Content-Type": "application/json"
    //             }
    //         });
    //         return responseBody(response);
    //     } catch (err: any) {
    //         return Error(err);
    //     }
    // }

    delete: async (url: string, payload?: any) => {
        try {
            const response = await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json"
                },
                data: payload,
            });
            return responseBody(response);
        } catch (err: any) {
            return Error(err);
        }
    }

};

// ---------- USER AUTH ----------
const getUserAppWithStatusApi = {
    get: () => requests.get("/api/v2/user/apps")
}

const logoutAPI = {
    get: () => requests.get("/api/user/logout-user")
}
// ---------- USER AUTH ----------


// ---------- VERSION 2 ----------
const userRegistrationAPI = {
    // post: (payload: UserRegistrationPayloadModel) => requests.post("/api/user/register", payload)
    post: (payload: UserRegistrationPayloadModel) => requests.post("/api/v2/user/register", payload)
}

const getAppAccessDataApi = {
    // get: (payload: any) => requests.get("/api/user-app-access/get-access-requests?access_status=" + payload)
    get: (payload: any) => requests.get("/api/v2/user-app-access/get-access-requests?access_status=" + payload)
}

const appInstallApi = {
    // post: (payload: AppAccessRequestInterface) => requests.post("/api/user-app-access/install-app", payload)
    post: (payload: AppAccessRequestInterface) => requests.post("/api/v2/user-app-access/install-app", payload)
}

const userDetailAPI = {
    // get: () => requests.get("/api/user/get-user-detail")
    get: () => requests.get("/api/v2/user/get-user-detail")
}

const appAccessRequestApi = {
    // post: (payload: AppAccessRequestInterface) => requests.post("/api/user-app-access/request-access", payload)
    post: (payload: AppAccessRequestInterface) => requests.post("/api/v2/user-app-access/request-acces", payload)
}

const appApproveRejectApi = {
    // post: (payload: AppApproveRejectInterface) => requests.post("/api/user-app-access/update-access-request", payload)
    post: (payload: AppApproveRejectInterface) => requests.post("/api/v2/user-app-access/update-access-request", payload)
}

const signInAPI = {
    // post: (payload: loginPayloadModel) => requests.post("/api/user/login", payload)
    post: (payload: loginPayloadModel) => requests.post("/api/v2/user/login", payload)
}

const getUserGroupsApi = {
    // get: () => requests.get("/api/global/get-user-groups")
    get: () => requests.get("/api/v2/global/get-user-groups")
}

const getRegisteredSitesV2Api = {
    get: () => requests.get("/api/v2/global/get-registered-sites")
}
// ---------- VERSION 2 ----------



const getStateOptions = {
    get: () => requests.get("api/global/get-us-states")
}

const getUserProfileDetailsAPI = {
    get: () => requests.get("api/user/get-profile")
}

const userProfileDetailsUpdateAPI = {
    put: (payload: UserProfileDetailsPayloadModel) => requests.put("api/user/update-profile", payload)
}

const forgotPasswordAPI = {
    post: (payload: forgotPasswordPayloadModel) => requests.post("api/user/change-password", payload)
}

const forgotPasswordLinkAPI = {
    post: (payload: forgotPasswordEmailInterface) => requests.post("api/user/send-reset-password-link", payload)
}

const getUserDashboardAPI = {
    get: () => requests.get("api/dashboard")
}

const changeAppOrderApi = {
    put: (payload: AppsOrderPayload) => requests.put("api/v2/user/app-order", payload)
}

const getMarketingViewDetailsAPI = {
    get: () => requests.get("api/dashboard/marketing-view-details")
}

const getUserMarketingViewAPI = {
    get: () => requests.get("api/dashboard/marketing-view")
}

const getUserMarketingPortfolioAPI = {
    get: () => requests.get("api/dashboard/marketing-portfolio")
}

const getRevenueDataAPI = {
    post: (payload: getRevenuePayloadData) => requests.post("api/revenue", payload)
}

const revenueGeneratePdfAPI = {
    post: (payload: getRevenuePayloadData) => requests.post("api/revenue/generate-pdf", payload, { responseType: 'blob', })
}

const getRedTailSsoAPI = {
    get: () => requests.get("api/sso/get-redtail-sso")
}

const redtailCredentialAPI = {
    post: (payload: any) => requests.post("api/sso/save-redtail-cred", payload)
}

const getBrokersAllianceSSOAPI = {
    get: () => requests.get("api/sso/get-brokersalliance-sso")
}

const getBrooklightSSOAPI = {
    get: () => requests.get("api/sso/get-brooklight-sso")
}

const getLifeBrainSSOAPI = {
    get: () => requests.get("api/sso/get-lifebrain-sso")
}

const getRetirementBrainSSOAPI = {
    get: () => requests.get("api/sso/get-retirementbrain-sso")
}

const getMarketAndSalesDetailsAPI = {
    get: () => requests.get("/api/market-and-sales")
}

const marketAndSalesResourceAPI = {
    post: (payload: MarketAndSalesResourcePayloadDataModel) => requests.post("/api/market-and-sales", payload)
}

const marketAndSalesResourceUpdateAPI = {
    put: (payload: updateResourceInterface) => requests.put("/api/market-and-sales", payload)
}

const uploadResourceFileAPI = {
    post: (payload: any) => requests.fileUploadPost("/api/google-cloud", payload)
}

const deleteResourceFileAPI = {
    delete: (payload: any) => requests.delete("/api/google-cloud/delete-file-resource?id=" + payload, {})
}

const deleteMarketAndSalesSubject = {
    delete: (payload: any) => requests.delete("/api/market-and-sales", payload)
}

const verifyUser = {
    post: (payload: any) => requests.post("/api/user/verify-user", payload)
}

const resendVerifyUser = {
    post: (payload: forgotPasswordEmailInterface) => requests.post("/api/user/resend-verification-email", payload)
}

const macssoVerifyUserApi = {
    post: (payload: MacSsoVerifyUserPayloadModel) => requests.post("/api/macsso/ssohome", payload)
}


// ---------- USER MODULE ----------
const getUsersListDetailsApi = {
    get: () => requests.get("/api/user/get-users")
}

const getUsersListDetailsApiV2 = {
    get: (payload: any) => requests.get(`/api/user/get-users-v2?filterModel=${payload?.filterModel}&paginationModel=${payload?.paginationModel}&sortModel=${payload?.sortModel}`)
}

const updateUserStatusApi = {
    put: (payload: UpdateUserStatusByPayloadModel) => requests.put("/api/v2/user/update-user", payload)
}

const updateUserStatusApiGroup = {
    put: (payload: any) => requests.put("/api/v2/user/update-user", payload)
}

const getUsersByParamsApi = {
    get: (payload: GetUserDetailsPayloadModel) => requests.get(`/api/user/get-users?searchString=${payload?.searchString}&userId=${payload?.userId}`)
}

const getUsersStatusApi = {
    get: () => requests.get("/api/global/get-user-status")
}

const updateChangeGroupApi = {
    put: (payload: UpdateMemberDetailsPayload) => requests.put("/api/user/change-group", payload)
}

const getUsersCredentialsApi = {
    get: (payload: GetUserCredPayloadModel) => requests.get(`/api/user/get-user-credentials?userId=${payload.userId}`)
}

const changeUserCredentialsApi = {
    post: (payload: any) => requests.post("/api/user/change-user-credentials", payload)
}
// ---------- USER MODULE ----------


// ---------- ACRYLIC TEAM ----------
const getAcrylicTeamMemberApi = {
    get: (payload: GetAcrylicPayloadModel) => requests.get(`/api/team/get-team?flagGetAll=${payload?.flagGetAll}&assignedToUserId=${payload?.assignedToUserId}`)
}

const getAcrylicTeamMemberDashboardApi = {
    get: (query: any) => requests.get(`/api/team/get-team?${query}`)
}

const addAcrylicTeamApi = {
    post: (payload: AcrylicTeamMemberPayloadModel) => requests.post("/api/team/add-team", payload)
}

const updateAcrylicTeamApi = {
    put: (payload: AcrylicTeamMemberPayloadModel) => requests.put("/api/team/edit-team", payload)
}

const deleteAcrylicTeamApi = {
    delete: (payload: any) => requests.delete(`/api/team/delete-team?acrylicTeamId=${payload?.acrylicTeamId}`)
}

const updateAcrylicTeamOrderApi = {
    put: (payload: any) => requests.put("/api/team/order-default-team", payload)
}
// ---------- ACRYLIC TEAM ----------


// ---------- PLAN 401K ----------
const getAcrylicFeeDetailsApi = {
    get: () => requests.get(`/api/fee-comparison/get-acylic-fee`)
}

const saveAcrylicFeeDetails = {
    post: (payload: Plan401kPayloadModel) => requests.post("/api/fee-comparison/save-acrylic-fee-details", payload)
}

const feeComparisonPDFApi = {
    post: (payload: any) => requests.post("/api/fee-comparison/get-fee-comparison-pdf", payload)
}
// ---------- PLAN 401K ----------




// ---------- USER GROUP ----------
const getGroupDetailsByGroupApi = {
    get: () => requests.get(`/api/v2/group/get-group-with-user-count`)
}

const getGroupAppswithStatusApi = {
    get: (payload: appGroupIdPayload) => requests.get(`/api/v2/group/get-apps?groupId=${payload?.groupId}`)
}

const getMacappwithDefaultStatusApi = {
    get: () => requests.get(`/api/v2/mac-app/get-mac-app-list`)
}

const getAppStatusOptionApi = {
    get: () => requests.get(`/api/v2/global/get-app-status`)
}

const addGroupAppandStatusApi = {
    post: (payload: GroupAppStatusRequestPayload) => requests.post(`/api/v2/group/add`, payload)
}

const editGroupAppandStatusApi = {
    put: (payload: GroupAppStatusRequestPayload, groupId: number) => requests.put(`/api/v2/group/edit`, payload, { groupId })
}

const deleteGroupAppApi = {
    delete: (payload: appGroupIdPayload) => requests.delete(`/api/v2/group/delete?groupId=${payload.groupId}`)
}
// ---------- USER GROUP ----------


// ---------- USER PROFILE ----------
const deleteUserProfileCredentials = {
    post: (payload: RemoveProfileCredPayload) => requests.post(`/api/user/delete-user-credentials`, payload)
}
// ---------- USER PROFILE ----------

const marketSymoboleListSearchString = {
    get: (searchString: string) => requests.get(`/api/v2/market-symbol/list?searchString=${encodeURIComponent(searchString)}`),
}

const getUserStocksSymboleDetails = {
    get: () => requests.get(`/api/v2/market-symbol/user-symbol`),
}

const updateUserTickerDetails = {
    post: (payload: any) => requests.post(`/api/v2/market-symbol/upsert-user-symbol`, payload)
}

const agent = {
    // ---------- USER AUTH ----------
    getUserAppWithStatusApi,
    getRegisteredSitesV2Api,
    // ---------- USER AUTH ----------

    // ---------- DASHBOARD ----------
    changeAppOrderApi,
    marketSymoboleListSearchString,
    updateUserTickerDetails,
    getUserStocksSymboleDetails,
    // ---------- DASHBOARD ----------

    getStateOptions,
    signInAPI,
    userDetailAPI,
    getUserProfileDetailsAPI,
    userProfileDetailsUpdateAPI,
    userRegistrationAPI,
    logoutAPI,
    forgotPasswordAPI,
    forgotPasswordLinkAPI,
    getUserDashboardAPI,
    getMarketingViewDetailsAPI,
    getUserMarketingViewAPI,
    getUserMarketingPortfolioAPI,
    getRevenueDataAPI,
    revenueGeneratePdfAPI,
    getRedTailSsoAPI,
    redtailCredentialAPI,
    getBrokersAllianceSSOAPI,
    getLifeBrainSSOAPI,
    getRetirementBrainSSOAPI,
    getMarketAndSalesDetailsAPI,
    marketAndSalesResourceAPI,
    marketAndSalesResourceUpdateAPI,
    uploadResourceFileAPI,
    deleteResourceFileAPI,
    deleteMarketAndSalesSubject,
    verifyUser,
    resendVerifyUser,
    getAppAccessDataApi,
    appAccessRequestApi,
    appApproveRejectApi,
    appInstallApi,
    macssoVerifyUserApi,


    // ----------------------------------------------- USER MODULE -----------------------------------------------
    getUsersListDetailsApi,
    updateUserStatusApi,
    updateUserStatusApiGroup,
    getUserGroupsApi,
    getUsersStatusApi,
    getUsersByParamsApi,
    changeUserCredentialsApi,

    // ---------- ACRYLIC TEAM ----------
    getAcrylicTeamMemberApi,
    getUsersCredentialsApi,
    addAcrylicTeamApi,
    updateAcrylicTeamApi,
    deleteAcrylicTeamApi,
    getUsersListDetailsApiV2,
    getBrooklightSSOAPI,
    getAcrylicTeamMemberDashboardApi,
    updateAcrylicTeamOrderApi,

    // ---------- USER GROUP ----------
    getGroupDetailsByGroupApi,
    getGroupAppswithStatusApi,
    getAppStatusOptionApi,
    getMacappwithDefaultStatusApi,
    addGroupAppandStatusApi,
    editGroupAppandStatusApi,
    deleteGroupAppApi,
    // ----------------------------------------------- USER MODULE -----------------------------------------------

    // ---------- PLAN 401K ----------
    getAcrylicFeeDetailsApi,
    saveAcrylicFeeDetails,
    feeComparisonPDFApi,
    // ---------- PLAN 401K ----------

    // ---------- PROFILE ----------
    deleteUserProfileCredentials,
    // ---------- PROFILE ----------
};

export default agent;


